<template lang="pug">
.wrapper.pt-header65
  header.gheader.-white.gheader-fix
    .gheader__link-back
      a(@click="backHome", href="javascript:void(0)") キャンセル
  .container.service-uncheck.bg04
    .row(v-if="serviceNoAnswers.length && serviceNoAnswers[0]['is_passed']")
      .cols-xs-12
        p.passed_warning.text-center 先月の評価表が完了していません。
        p.passed_warning 
          | ※3日までに入力完了するか、
          br
          | 休職者であれば未入力のままにしてください。
    .row.inner
      .user-post-detail__body__others.bg05
        div(v-if="serviceNoAnswers", v-for="(serviceAnswer,index) in serviceNoAnswers")
          a(@click="openModal(serviceAnswer['service_question_answer_id'])", href="javascript:void(0)") 
            div(:class="`service-uncheck-line ${serviceAnswer['is_passed'] ? 'service-uncheck-line-passed' : ''}`")
              .row
                .col-xs-8
                  .user-outline
                    .user-outline__img(v-if="serviceAnswer['profile_image_path']")
                      img(v-bind:src="serviceAnswer['profile_image_path'] + '?token=' + authToken + '&timestamp=' + timeStamp")
                    .user-outline__img(v-else)
                      img(src='./images/img_profile.png', alt='')
                    .user-outline__body
                      p.user-outline__body__role.fz11 {{serviceAnswer['shop_name']}} {{serviceAnswer['user_type_name']}}
                        span.passed_warning_line(v-if="serviceAnswer['is_passed']") ※先月の評価
                      h3.user-outline__body__name.fz16 {{serviceAnswer['user_name']}}
                .col-xs-4
                  .user-outline__body.text-right
                    p 回答数
                    p(v-if="serviceAnswer['answered_count'] == 0") 未回答
                    p(v-else) {{serviceAnswer['answered_count']}}/{{serviceAnswer['question_count']}}
  button#serviceAnserEditModalButton.hide(type="button", data-backdrop="static", data-toggle="modal" data-target="#serviceAnserEditModal") モーダル発火用
  #serviceAnserEditModal.help-modal
    .stepup-caution-bg.home__step-up-modal__body(style="margin-top: 20px; margin-bottom: 20px;")
      .mb25.fz11
        p 評価を実施するにあたり、
        p.home__step-up-modal__txt-red 次の3点に留意して評価をお願いいたします。
      .box_01.home__step-up-modal__body__txt
        .fz18.brown
          ol.bold.brown.fz16
            li 好き嫌いや相性といった感情的なものに影響されないようにお願いいたします
            br
            li 目視で確認の上、「常態」の評価をしてください 
            br
            li 本人の成長を願い公平で客観的な評価をお願いいたします
      button.btn02.-home-style.-step-up(type="button",v-on:click="goAnswer()", data-dismiss="modal")
        span 回答をはじめる
</template>
<script>
export default {
  name: 'service-answer-list',
  created () {
    this.search()
  },
  data () {
    return {
      serviceNoAnswers: [],
      selectedServiceQuestionAnswerId: undefined
    }
  },
  computed: {
    authToken () {
      return window.localStorage.getItem('access_token')
    },
    timeStamp () {
      var d = new Date()
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate()
      var hour = (d.getHours() < 10) ? '0' + d.getHours() : d.getHours()
      var min = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year + '' + month + '' + day + '' + hour + '' + min + '' + sec
    }
  },
  methods: {
    async search () {
      const data = {}
      // URLパラメータからservice_question_idを取得
      if (this.$route.query.service_question_id) {
        data.service_question_id = this.$route.query.service_question_id
      }
      let res = await this.$store.dispatch('SERVICE_ANSWER_TARGET_LIST', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      this.serviceNoAnswers = res
    },
    backHome: function () {
      this.$router.push({ path: '/' })
    },
    openModal: function (serviceQuestionAnswerId) {
      this.selectedServiceQuestionAnswerId = serviceQuestionAnswerId
      var button = document.getElementById('serviceAnserEditModalButton')
      button.click() // モーダル表示 イベント発火
    },
    goAnswer: function (serviceQuestionAnswerId) {
      this.$router.push({ path: '/service_answers/' + this.selectedServiceQuestionAnswerId })
    }
  }
}
</script>
<style scoped>
.service-uncheck-line-passed {
  background-color: #fee0e0;
}
.passed_warning {
  color: #ff0000;
  margin: 8px 16px 0px;
  font-weight: bold;;
}
.passed_warning_line {
  color: #ff0000;
  padding-left: 8px;
  font-weight: bold;;
}
</style>


// WEBPACK FOOTER //
// ServiceAnswerList.vue?b534a0ac